// useSafeMediaKey.js - Utilidad para generar identificadores seguros y únicos para multimedia

/**
 * Genera un identificador seguro y único para recursos multimedia (imagen, video, audio, etc.)
 * @param {Object} params
 * @param {string} params.prefix - Prefijo del tipo de recurso ("image", "video", etc.)
 * @param {string|number} params.messageIdentifier - Identificador único del mensaje
 * @param {string|number} params.accountUID - UID seguro de la cuenta
 * @param {number} params.counter - Contador de reintentos o versión
 * @param {boolean} [params.lastChance] - Flag para el último intento (opcional)
 * @returns {string} Key seguro para usar en React
 */
/**
 * Construye una key única y segura para recursos multimedia o cualquier recurso que requiera identificador compuesto.
 * @param {Object} params
 * @param {string} params.prefix - Prefijo del tipo de recurso ("image", "video", etc.)
 * @param {string|number} params.messageIdentifier - Identificador único del mensaje
 * @param {string|number} params.accountUID - UID seguro de la cuenta
 * @param {number} params.counter - Contador de reintentos o versión
 * @param {boolean} [params.lastChance] - Flag para el último intento (opcional)
 * @returns {string} Key segura para usar en React
 */
export function buildMediaKey({ prefix, messageIdentifier, accountUID, counter, lastChance }) {
  return `${prefix}-${messageIdentifier}-${accountUID ?? ''}-${counter}${lastChance ? '-last' : ''}`;
}

/**
 * Devuelve un identificador seguro para cualquier recurso (no solo multimedia)
 * @param {string|number} id
 * @returns {string}
 */
export function buildSafeIdentifier(id) {
  return id ?? '';
}
